module.exports = __webpack_public_path__ + "static/media/dashboard_light.aa548a04.svg";